import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
// import createLogger from 'vuex/dist/logger'
import auth from './modules/auth/auth'
import referral from './modules/auth/referral'
import invite from './modules/auth/invite'
import UI from './modules/ui/UI'
// namespaced:
import sidebar from './modules/app/sidebar'
import automations from './modules/automations'
import data from './modules/app/data'
import documents from './modules/documents'
import doc_type_permissions from './modules/documents/permissions'
import dt_views from './modules/documents/views'
import bulk_actions from './modules/documents/bulk-actions'
import billing from './modules/billing'
import inbox from './modules/inbox'

import doc_viewer from './modules/doc-viewer'
import doc_viewer_po from './modules/doc-viewer/matching/purchase-order'
import doc_viewer_supplier_receipt from './modules/doc-viewer/matching/supplier-receipt'
import doc_viewer_metadata from './modules/doc-viewer/metadata'
import doc_viewer_settings from './modules/doc-viewer/settings'
import doc_viewer_access_level from './modules/doc-viewer/access-level.js'
import Workflow from './modules/workflow'
import workflow_permissions from './modules/workflow/permissions'
import workflow_global_properties from './modules/workflow/global-properties'

const modules = {
    UI,
    Workflow,
    auth,
    referral,
    sidebar,
    data,
    invite,

    // namespaced:
    automations,
    billing,
    inbox,
    documents,
    doc_type_permissions,
    bulk_actions,
    dt_views,

    doc_viewer,
    doc_viewer_po,
    doc_viewer_supplier_receipt,
    doc_viewer_metadata,
    doc_viewer_settings,
    doc_viewer_access_level,

    workflow_global_properties,
    workflow_permissions,

    extend_route: {
        namespaced: true,
        state: {
            prevRoute: null,
            currentRoute: null
        },
        getters: {
            getPrevRoute: (state) => state.prevRoute,
            isPrevRouteInApp: (state) => {
                if (state.prevRoute !== null) {
                    return state.prevRoute.path !== '/' && state.prevRoute.name !== null
                } else {
                    return false
                }
            }
        },
        mutations: {
            setPrevRoute: (state, route) => {
                state.prevRoute = route
            },
            setCurrentRoute: (state, route) => {
                state.currentRoute = route
            }
        }
    }
}

Vue.use(Vuex)

const store = new Vuex.Store({
    modules,
    // strict: process.env.NODE_ENV !== 'production',
    plugins: [
        createPersistedState()
        // createLogger()
    ]
})

export default store
